import { Component, Inject, OnInit } from '@angular/core';
import {BaseCustomDialog} from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CONTACTS_DATA_SERVICE, ContactsDataService } from '../../../../services/contacts/contacts-data.service';
import { ContactsModel } from '../../../../models/contacts/contacts.model';
import { PhoneNumberHelper } from '../../../../helper/phone-number.helper';


@Component({
  selector: 'fi-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
  standalone: false,
})

export class ContactInfoComponent extends BaseCustomDialog implements OnInit {
  contactToDisplay: ContactsModel;
  constructor(public dialogRef: MatDialogRef<ContactInfoComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: { id: number },
              @Inject(CONTACTS_DATA_SERVICE) private contactsDataService: ContactsDataService,
  ) {
    super(dialogRef);

    contactsDataService.getContacts(dialogData.id).subscribe(({success, data}) => {
      if (success) {
        this.contactToDisplay = data;
      }
    });
  }

  ngOnInit(): void {
  }

  get contactPhone(): string {
    return PhoneNumberHelper
        .getPhoneNumber(this.contactToDisplay?.PhonePrefix, this.contactToDisplay?.Phone);
  }

  get contactMobile(): string {
    return PhoneNumberHelper
        .getPhoneNumber(this.contactToDisplay?.MobilePrefix, this.contactToDisplay?.Mobile);
  }

  onClosePopup(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }
}
